module.exports = __webpack_public_path__ + "static/media/folded-hands-svgrepo-com.6454215d.svg";